module.exports = __webpack_public_path__ + "media/public/img/getyourguide-round-color-01-387e9c9c55baeb03044eb106b914ed38.svg";